module.exports = {
  GOOGLE_SIGNIN_FROM: 'googleSigninFrom',
  GOOGLE_SIGNIN_SOURCE: 'googleSigninSource',
  IS_WRAPUP_HIDDEN: 'isWrapupHidden',
  GOOGLE_SIGNIN_REDIRECT: 'googleSigninRedirect',
  GOOGLE_SIGNIN_SAVE_WORDCLOUD: 'googleSigninSaveWordcloud',
  GOOGLE_SIGNIN_SAVE_SPINNER_WHEEL: 'googleSigninSaveSpinnerWheel',
  CANVAS_RIGHT_CLICK: 'canvasRightClick',
  HAS_USED_GIPHY: 'hasUsedGiphy',
  AHA_GUEST_USER: 'aha-guest-user',
  ASK_AI_BUTTON_CLICKED: 'ask-ai-button-clicked',
  AI_INSIGHTS_ASK_AI_BUTTON_CLICKED: 'ai-insights-ask-ai-button-clicked',
  UNLEASH_MECHANISM_ASSIGNMENT_VALUE: 'unleashMechanismAssignmentValue',
  MIXPANEL_LOCALSTORAGE_ASSIGNMENT_VALUE: 'mixpanelLocalStorageAssignmentValue',
  CACHE_PROFILE_ASSIGNMENT_VALUE: 'cacheProfileAssignmentValue',
  OAUTH_LOGIN_ASSIGNMENT_VALUE: 'oauthLoginAssignmentValue',
  PPT_ZERO_CLICK_SIGN_IN_ASSIGNMENT_VALUE: 'pptZeroClickSignInAssignmentValue',
  // BOO-203: forced Unleash flag overrides from the URL (dev/test tooling).
  UNLEASH_OVERRIDE: 'unleashOverride',
  ASSISTANT_LAUNCHER_TIP_SEEN: 'assistantLauncherTipSeen',
  // User ids that have acknowledged the one-time "you can edit this list"
  // coachmark on the slide-type picker (shown only to users who've hosted).
  MARKETPLACE_EDIT_LIST_COACHMARK_SEEN: 'marketplaceEditListCoachmarkSeen',
  // User ids that had NOT hosted yet the first time they saw the picker, so the
  // "has hosted" snapshot is locked to new-user — hosting later never resurfaces
  // the edit-list coachmark for them.
  MARKETPLACE_EDIT_LIST_COACHMARK_INELIGIBLE: 'marketplaceEditListCoachmarkIneligible',
  // User ids that have customised their pinned slide types (reordered, removed,
  // or pinned/unpinned). Lets the picker show a skeleton for "My slide types"
  // while the saved list loads after a reload, instead of flashing the defaults.
  MARKETPLACE_CUSTOMISED_PINS: 'marketplaceCustomisedPins',
  // AHA-46714: the editor Back arrow's destination ({ userId, path }).
  // sessionStorage: one-tab scope, matching what history.back() used to give.
  EDITOR_LAST_DESTINATION: 'editorLastDestination',
  // AHA-47740: set only while the export modal's "Include speaker notes" box is
  // ticked, so a user who ticks it keeps it ticked; unticking removes the key
  // (unticked is the default), keeping it out of the majority's localStorage.
  EXPORT_INCLUDE_SPEAKER_NOTES: 'exportIncludeSpeakerNotes',
  // AHA-47094: user ids that have seen the one-time "Convert to lesson"
  // discovery nudge in the editor header, and user ids that have already used
  // the action (who are never nudged about it).
  CONVERT_TO_LESSON_NUDGE_SEEN: 'convertToLessonNudgeSeen',
  CONVERT_TO_LESSON_USED: 'convertToLessonUsed',
}
